import React from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import classnames from 'classnames';
import propTypes from 'prop-types';
import Modal from '../Modal';
import Input from '../Input';

export default function AuthCode({ toggle, onSubmit }) {
  const { values, touched, errors, setErrors, handleChange, handleSubmit, isSubmitting } = useFormik({
    initialValues: { code: '' },
    validationSchema: yup.object({
      code: yup.string().required(),
    }),
    onSubmit: async ({ code }) => {
      try {
        await onSubmit(`${code}`);
      } catch (e) {
        setErrors({ code: 'invalid' });
        setTimeout(() => setErrors({}), 1000);
      }
    },
  });

  return (
    <Modal className="bg-dark" sm>
      <form className="form" onSubmit={handleSubmit}>
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLongTitle">
              Estamos quase lá
            </h5>
            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={toggle}>
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <div className="form-group text-center">
              <label>
                Insira o código de confirmação
                <br />
                recebido por SMS
              </label>
              <Input
                focus
                className={classnames({
                  'is-invalid': errors.code && touched.code,
                })}
                type="tel"
                name="code"
                value={values.code}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="modal-footer">
            <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
              {isSubmitting ? 'Validando' : 'Validar'}
            </button>
          </div>
        </div>
      </form>
    </Modal>
  );
}

AuthCode.propTypes = {
  toggle: propTypes.func.isRequired,
  onSubmit: propTypes.func.isRequired,
};
